import './HomeCertificate.css'
import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import { messages, options, severProperties } from './utility/Constants';
import axios from 'axios';
import addHookTo from './AddHookTo';
import HeaderMenu from './HeaderMenu';
import { getToken,getRefreshToken,getLocaleLanguage } from './AuthService';
import { Navigate } from 'react-router';
import Button from '@mui/material/Button';
import moment from 'moment';
import { RotatingLines } from "react-loader-spinner";
import { generateReportName } from "./utility/ReportName";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
class DownloadReport extends Component {
  constructor(props) {
    super(props);
    this.state =
    {
      locale: 'en',
      dataField: [],
      cxrField: [],
      loading: true
    };

    this.downloadPdf = this.downloadPdf.bind(this);
    this.downloadCertificate = this.downloadCertificate.bind(this); 
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
  }

  componentDidMount() {
    this.setState({ locale: getLocaleLanguage() });
    this.setState({ dataField: '', loading: true });
    this.fetchData();
    this.fetchCXRDetails();
    
    <HeaderMenu setlocale="{this.state.locale}" />

    /*axios.get("https://mocki.io/v1/b4049563-268c-4408-8997-4e04e6a74e04") 
      .then(response => {
        const dataField = response.data;
        this.setState({ dataField });
      });*/
  }

  fetchData = async () => {
    const token = getRefreshToken(); // Replace with your actual token
    const apiUrl = [severProperties.serverURL,"/file/reportAvailability"].join("");//'http://localhost:8084/applicant/application'; // Replace with your API URL
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Access-Control-Allow-Origin': severProperties.serverCORS,
        },
      });
      this.setState({ dataField: response.data, loading: false });
    } catch (error) {
      if(error.message === "Network Error")
        {
            alert("Session Expired or Invalid");
            this.props.navigate('/');
        }
        else
        {
          alert("Session Expired or Invalid");
          this.props.navigate('/');        
        }
    }
  };

  fetchCXRDetails = async () => {
    const token = getRefreshToken(); // Replace with your actual token
    const apiUrl = [severProperties.serverURL,"/file/cxrDetails"].join("")+"?aplReferenceId="+sessionStorage.getItem("user");//'http://localhost:8084/applicant/application'; // Replace with your API URL
        
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Access-Control-Allow-Origin': severProperties.serverCORS,
        },
      });
      this.setState({ cxrField: response.data, loading: false });
    } catch (error) {
      if(error.message === "Network Error")
        {
            alert("Session Expired or Invalid");
            this.props.navigate('/');
        }
        else
        {
          alert("Session Expired or Invalid");
          this.props.navigate('/');        
        }
    }
  };

  componentWillUnmount() {
    this.setState({ locale: getLocaleLanguage() });
  }


  handleLanguageChange = (e) => {
    this.setState({ locale: e.target.value });
    localStorage.setItem('laguagePrefered', e.target.value);
  };

  checkString(str1,str2)
  {
    return str1.includes(str2);
  }

  downloadPdf = async (e,applicationId,reportName,appMap,fileType)=> 
  {
    this.setState({ loading: true });
    try {
    const token = getRefreshToken();
    const response = await axios.get(severProperties.serverURL+'/file/report?applicationId='+applicationId+'&reportName='+reportName+'&fileType='+fileType, {
      headers: { accept: 'application/pdf','Content-Type': 'application/pdf', 
        Authorization: `Bearer ${token}`,
        'Access-Control-Allow-Origin': severProperties.serverCORS,
      },
      responseType: 'arraybuffer',
    })
 
    const blob = new Blob([response.data], {
     
        type: (reportName==="CXRDCM")?((fileType==="dicom")?'application/dicom':'image/jpeg'):'application/pdf',
     })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
 
    a.href = url
    var extension;
    if(fileType==="dicom")
      extension='.dcm';
     else if(fileType==="jpeg")
      extension= '.jpeg';
    else
      extension= '.pdf';

    a.download = generateReportName(reportName,appMap)+ extension
    a.click();
    this.setState({ loading: false });
  }
    catch (error) {
    this.setState({ loading: false });
      if (axios.isAxiosError(error)) {
        // Handle Axios-specific errors
        console.error('Error:', error.message);
        if (error.code === 'ERR_NETWORK_IO_SUSPENDED') {
          // Handle the specific error
          alert('Network request was suspended. Please try again later.');
        }
      } else {
        // Handle other types of errors
        console.error('Unexpected error:', error);
      }
    }

  };

  downloadCertificate = async (e,applicationId,appMap)=> 
  {
    this.setState({ loading: true });
    try {
    const token = getRefreshToken();
    const response = await axios.get(severProperties.serverURL+'/applicant/download?applicationId='+applicationId+'&certificateNo='+appMap.aprMcNumber, {
      headers: { accept: 'application/pdf','Content-Type': 'application/pdf', 
        Authorization: `Bearer ${token}`,
        'Access-Control-Allow-Origin': severProperties.serverCORS,
      },
      responseType: 'arraybuffer',
    })
 
    const blob = new Blob([response.data], {
      type: 'application/pdf',
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
 
    a.href = url
 
    a.download = generateReportName("TB Clearance Certificate",appMap)+".pdf";
    //a.download = certificateNo+'.pdf'
    a.click();
    this.setState({ loading: false });
  }
    catch (error) {
    this.setState({ loading: false });
      if (axios.isAxiosError(error)) {
        // Handle Axios-specific errors
        console.error('Error:', error.message);
        if (error.code === 'ERR_NETWORK_IO_SUSPENDED') {
          // Handle the specific error
          alert('Network request was suspended. Please try again later.');
        }
      } else {
        // Handle other types of errors
        console.error('Unexpected error:', error);
      }
    }

  };

  compareDate(str1)
  {
    var d1 = new Date();
    var d2 = new Date(str1);
    return (d2>d1);
  }
  render() {
    function Loader() {
      return (
        <RotatingLines
          strokeColor="grey"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true} />
      )
    }
    
    if ((getToken() === "" || getToken() === null)) {
      return (<Navigate to="/" />);
    }
    if(!this.state.dataField && this.state.loading)
    {
      return(<div style={{display: 'flex',zIndex:'-moz-initial',height:'100vh',width:'100vw',justifyContent: 'center', alignItems: 'center'}}><Loader></Loader></div>)
    }
    else
    {
    return (
      <div className={`app ${this.state.loading ? 'blurred' : ''}`}>
      <IntlProvider locale={this.state.locale}
        messages={messages[this.state.locale]} defaultLocale="en" onError={(error) => { /* Handle missing message... */ }}>
        <div style={{ 'width': '100vw' }}>
          <HeaderMenu />
          
          <center style={{ 'marginTop': '10' }}> 
            
          <FormControl variant="standard" sx={{ m: 1, minWidth: 220 }}>
       
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={this.state.locale}
          onChange={this.handleLanguageChange}
          label="Language"
        >
          {options.map(option =>
              (
                 <MenuItem value={option.value} key={option.index}>{option.label}</MenuItem>
              )
            )
            }
          </Select>
      </FormControl>
      </center>
          <p/>
          <div style={{ 'padding': '10px', 'width':'100%', 'backgroundColor':'#3D74D5', 'color':'#FFF', 'fontWeight':'bolder'}}><big>Files</big></div>
          <p/>
          <div className="div-grid" style={{ 'margin': '20px' }}>
	  { 
              this.state.dataField.map(app =>(
                <>
            <div style={{'border':'1px #3D74D5 solid','display':'flex'}}>
              <div  style={{'backgroundColor':'#3D74D5','color':'white','padding':'5px'}}>
                {
                  app.aplExamDate
                    ? moment(new Date(app.aplExamDate)).format('DD-MMM-YYYY')
                    : ''
                } 
              </div>
              <div style={{'color':'#3D74D5','width':'60%','padding':'5px'}}>
                {app.locName}
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" style={{'padding':'20px','border':'1px #3D74D5 solid'}}>
              <p></p>
              
              <center>
    
    <>
    {(this.checkString(app.aplStatus,"Certificate Issued"))?
                <>
                <Button variant="outlined" style={{ 'maxWidth': '300px', 'minWidth': '300px' }} onClick={(e,applicationId,appMap)=>this.downloadCertificate(e,app.aplApplicationIdPk,app)} key="3">TB Clearance Certificate</Button>
                <p></p>
                </>
                :<></>}

          
          {(() => {
        const filteredCxrForApp = this.state.cxrField.filter((cxr) =>
          moment(cxr.study_date, "DD-MMM-YYYY").isSameOrAfter(
            moment(app.aplRegistrationDate, "YYYY-MM-DD"),
            "day"
          ) &&
          moment(cxr.study_date, "DD-MMM-YYYY").isSameOrBefore(
            moment(app.aplRegistrationDate, "YYYY-MM-DD").clone().add(14, "days"),
            "day"
          )
        );
 
        return filteredCxrForApp.map((cxr, index) => (
          <React.Fragment key={cxr.objectID || index}>
	  <Button
              variant="outlined"
              style={{ maxWidth: '300px', minWidth: '300px' }}
              onClick={(e, applicationId, reportName, appMap, fileType) => this.downloadPdf(e, cxr.objectID, "CXRDCM", app, "jpeg")}
            >
              CXR Image (.JPG) {index + 1} of {filteredCxrForApp.length} 
            </Button>
            <p></p>
            <Button
              variant="outlined"
              style={{ maxWidth: '300px', minWidth: '300px' }}
              onClick={(e, applicationId, reportName, appMap, fileType) => this.downloadPdf(e, cxr.objectID, "CXRDCM", app, "dicom")}
            >
              CXR Image (.DCM) {index + 1} of {filteredCxrForApp.length} 
            </Button>
            <p></p>
            
          </React.Fragment>
        ));
      })()}

            
                {app.historyPeDateVerified ? (
                <>
                          <Button variant="outlined" style={{ 'maxWidth': '300px', 'minWidth': '300px' }} onClick={(e, applicationId, reportName, appMap, fileType) => this.downloadPdf(e, app.aplApplicationIdPk, "Pre-Entry Tuberculosis Screening Results Report",app,"")} key="4">Pre-Entry Tuberculosis Screening Result Report</Button>
                          <p></p>
                        </>
                  ) : <></>} 
		  
		            {app.cxiDateVerified  ? (
    <><Button variant="outlined" style={{ 'maxWidth': '300px', 'minWidth': '300px' }} onClick={(e,applicationId,reportName,appMap,fileType)=>this.downloadPdf(e,app.aplApplicationIdPk,"CXR Report",app,"")} key="1">Chest Xray Report</Button>
                <p></p>
          </>      
        ) : <></>}
	
                  { app.tbTreatmentCertified ? 
                        <>
                            <Button variant="outlined" style={{ 'maxWidth': '300px', 'minWidth': '300px' }} onClick={(e, applicationId, reportName, appMap, fileType) => this.downloadPdf(e, app.aplApplicationIdPk, "Tuberculosis Treatment Report",app,"")} key="5">TB Treatment Report</Button>
                            <p></p>
                          </>
                           : <></>} 
				</>
              </center>
             
            </div>
            </>  
              ))}
          </div>

          <div className="footer">
            <p>© 2025 IOM. All rights reserved. version 1.0.0 </p>
          </div>
          
        </div>     </IntlProvider></div>);
    }
  }
}
//export default HomeCertificate;

export default addHookTo(DownloadReport);
